import React from 'react';

interface SummaryRowProps {
  label: string;
  children: React.ReactNode;
  labelCols?: string;
  valueCols?: string;
}

export function SummaryRow({
  label,
  children,
  labelCols = 'col-md-4 text-right',
  valueCols = 'col-md-8',
}: SummaryRowProps) {
  return (
    <div className="row">
      <div className={labelCols}>{label}</div>
      <div className={valueCols}>{children}</div>
    </div>
  );
}

interface BoolIconProps {
  value?: boolean;
}

export function BoolIcon({ value }: BoolIconProps) {
  return (
    <i
      className={value ? 'far fa-check-square fa-lg' : 'far fa-square fa-lg'}
      aria-hidden="true"
    />
  );
}

interface BadgesProps {
  items: string[];
}

export function Badges({ items }: BadgesProps) {
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {items.map(item => (
        <span key={item} className="label label-default">{item}</span>
      ))}
    </span>
  );
}
